module.exports = __webpack_public_path__ + "media/Schamanzs_1600.24b11048.mp4";